(function () {
  'use strict';

  /* Quick add from the cart recommendations */
  function refreshDrawer() {
    return fetch('/?sections=cart-drawer')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        var drawer = document.querySelector('[data-cart-drawer]');
        if (!drawer || !html) return;
        var wasOpen = drawer.classList.contains('is-open');
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var fresh = temp.querySelector('[data-cart-drawer]');
        if (fresh) {
          drawer.innerHTML = fresh.innerHTML;
          drawer.hidden = false;
          if (wasOpen) drawer.classList.add('is-open');
        }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
          el.textContent = cart.item_count;
        });
        return refreshDrawer();
      })
      .catch(function () { btn.disabled = false; });
  });
})();